import React from 'react';

export default function SortFilter({ sortOption, onSortChange, options }) {
  const defaultOptions = [
    { label: 'A - Z (Name)', value: 'a-z' },
    { label: 'Z - A (Name)', value: 'z-a' },
    { label: 'Newest First', value: 'newest' },
    { label: 'Oldest First', value: 'oldest' },
  ];

  const sortList = options || defaultOptions;

  return (
    <div className="sort-filter-container" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, height: 40 }}>
      <label style={{ fontSize: 13, fontWeight: 600, color: '#475569', display: 'flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M11 5h10M11 9h7M11 13h4M3 17l3 3 3-3M6 18V4" />
        </svg>
        Sort:
      </label>
      <select
        value={sortOption}
        onChange={(e) => onSortChange(e.target.value)}
        className="filter-select"
        style={{
          padding: '8px 12px',
          borderRadius: 8,
          border: '1px solid #cbd5e1',
          background: '#fff',
          fontSize: 14,
          fontWeight: 500,
          color: '#334155',
          cursor: 'pointer',
          outline: 'none',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
          boxSizing: 'border-box'
        }}
      >
        {sortList.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export function sortItems(items, sortOption, nameKey = 'name', dateKey = 'created_at') {
  if (!Array.isArray(items)) return [];
  const sorted = [...items];

  sorted.sort((a, b) => {
    if (sortOption === 'a-z') {
      const valA = String(a[nameKey] || a.name || a.full_name || a.title || '').toLowerCase();
      const valB = String(b[nameKey] || b.name || b.full_name || b.title || '').toLowerCase();
      return valA.localeCompare(valB);
    }
    if (sortOption === 'z-a') {
      const valA = String(a[nameKey] || a.name || a.full_name || a.title || '').toLowerCase();
      const valB = String(b[nameKey] || b.name || b.full_name || b.title || '').toLowerCase();
      return valB.localeCompare(valA);
    }
    if (sortOption === 'newest') {
      const dateA = new Date(a[dateKey] || a.created_at || a.activity_date || a.attendance_date || 0).getTime();
      const dateB = new Date(b[dateKey] || b.created_at || b.activity_date || b.attendance_date || 0).getTime();
      return dateB - dateA;
    }
    if (sortOption === 'oldest') {
      const dateA = new Date(a[dateKey] || a.created_at || a.activity_date || a.attendance_date || 0).getTime();
      const dateB = new Date(b[dateKey] || b.created_at || b.activity_date || b.attendance_date || 0).getTime();
      return dateA - dateB;
    }
    return 0;
  });

  return sorted;
}
